import { render, staticRenderFns } from "./cta.vue?vue&type=template&id=6ec3090a&scoped=true&"
import script from "./cta.vue?vue&type=script&lang=js&"
export * from "./cta.vue?vue&type=script&lang=js&"
import style0 from "./cta.vue?vue&type=style&index=0&id=6ec3090a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec3090a",
  null
  
)

export default component.exports